// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OX8iNpYseCYBHfahdYWE {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 1vmin 0;
  max-height: 5.38vmin;
  width: 94%;
  flex: 1;
  background-color: var(--tan-2);
  border-radius: 1.5vmin;
}

._1Z2WEFpVvU7TIl5e80u {
  width: 3vmin;
  height: auto;
  margin-right: 1vmin;
  margin-left: 1vmin;
}

.UGSsMFiwpVG1WGMqwbVg {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 1vmin;
}`, "",{"version":3,"sources":["webpack://./src/components/CoinPrice/CoinPrice.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;EACA,OAAA;EACA,8BAAA;EACA,sBAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,OAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;AACJ","sourcesContent":[".CoinPrice {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    margin: 1vmin 0;\n    max-height: calc((70vmin - 10vmin - 2 * 3vmin - 0.2vmin) / 10);\n    width: 94%;\n    flex: 1;\n    background-color: var(--tan-2);\n    border-radius: 1.5vmin;\n}\n\n.coinLogo {\n    width: 3vmin;\n    height: auto;\n    margin-right: 1vmin;\n    margin-left: 1vmin;\n}\n\n.coinInfo {\n    flex: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-right: 1vmin;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CoinPrice": `OX8iNpYseCYBHfahdYWE`,
	"coinLogo": `_1Z2WEFpVvU7TIl5e80u`,
	"coinInfo": `UGSsMFiwpVG1WGMqwbVg`
};
export default ___CSS_LOADER_EXPORT___;
